import { PaginationType } from '@nxsys/types/models/Common';
import { createSlice } from '@reduxjs/toolkit';
import { payrollActs } from '../action';
import { DraftPayroll } from '@nxsys/types/models/payroll';
import { GetDraftPayrollParams } from '../type';

interface PayrollState {
  draftPayroll: {
    loading: boolean;
    list: DraftPayroll[];
    pagination: PaginationType;
    totalDocs: number;
    success: boolean;
    queryParams: GetDraftPayrollParams | null;
  };
}

export const initialState: PayrollState = {
  draftPayroll: {
    loading: false,
    list: [],
    pagination: {
      current: 0,
      pageSize: 20,
      totalDocs: 0,
    },
    totalDocs: 0,
    success: false,
    queryParams: null,
  },
};

const payrollSlice = createSlice({
  name: 'payrollSlice',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get draft payroll list
    builder.addCase(payrollActs.getDraftPayrollList.pending, (state) => {
      state.draftPayroll.loading = true;
    });
    builder.addCase(
      payrollActs.getDraftPayrollList.fulfilled,
      (state, action) => {
        state.draftPayroll.loading = false;
        state.draftPayroll.pagination = action.payload.pagination;
        state.draftPayroll.list = action.payload.data;
        state.draftPayroll.totalDocs = action.payload.totalDocs;
        state.draftPayroll.success = action.payload.success;
        state.draftPayroll.queryParams = action.payload.queryParams;
      },
    );
    builder.addCase(payrollActs.getDraftPayrollList.rejected, (state) => {
      state.draftPayroll.loading = false;
    });
  },
});

export const payrollReducer = payrollSlice.reducer;
export const payrollActions = {
  ...payrollSlice.actions,
  ...payrollActs,
};
